import { render, staticRenderFns } from "./pageElementCustom.vue?vue&type=template&id=69f4f227&"
import script from "./pageElementCustom.vue?vue&type=script&lang=js&"
export * from "./pageElementCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports